import { accountsReducers } from '../reducers'

export const accountsRootReducers = {
  accounts: accountsReducers,
}
